import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'trademark', 'Trademark', [["path",{"d":"M4.5 9h5m-2.5 0v6"}],["path",{"d":"M13 15v-6l3 4l3 -4v6"}]]);